"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Emitter = void 0;

require("core-js/modules/es.array.filter.js");

require("core-js/modules/web.dom-collections.for-each.js");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var Emitter = /*#__PURE__*/function () {
  function Emitter() {
    (0, _classCallCheck2.default)(this, Emitter);
    this.subscribers = [];
  }

  (0, _createClass2.default)(Emitter, [{
    key: "hasSubscribers",
    get: function get() {
      return Boolean(this.subscribers.length);
    }
  }, {
    key: "addListener",
    value: function addListener(f) {
      this.subscribers.push(f);
    }
  }, {
    key: "removeListener",
    value: function removeListener(fOnRemove) {
      this.subscribers = this.subscribers.filter(function (f) {
        return f !== fOnRemove;
      });
    }
  }, {
    key: "emit",
    value: function emit(value) {
      this.subscribers.forEach(function (f) {
        return f(value);
      });
    }
  }]);
  return Emitter;
}();

exports.Emitter = Emitter;